import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import Button from "../../coraWebComponents/buttons/Button";
import Textarea from "../../coraWebComponents/forms/Textarea";
import Tooltip from "../../coraWebComponents/forms/Tooltip";
import Upload from '../../coraWebComponents/forms/Upload';
import withRouter from "../../coraWebComponents/utils/withRouter";
import { showMsg } from '../../coraWebComponents/utils/logger';  

// actions
import * as ziadostActions from "../../actions/ziadostActions";

import _ from "lodash";

class PrilohyKomentare extends React.Component {
  constructor(props) {
    super(props);

    const PrilohyKomentar = props.ziadost.PrilohyKomentar;
    this.state = {
      KOMENTAR: PrilohyKomentar ? PrilohyKomentar.KOMENTAR : "",
      prilohy: PrilohyKomentar ? PrilohyKomentar.prilohy : [],
      filesNames: PrilohyKomentar && PrilohyKomentar.filesNames ? PrilohyKomentar.filesNames : [],
      titles: {
        komentar: "Komentár",
        prilohy: "Prílohy",
      },
    };
  }

  saveData = async () => {
    const { KOMENTAR, prilohy, filesNames } = _.cloneDeep(this.state);

    const data = {
      prilohy,
      KOMENTAR,
      filesNames,
    };

    this.props.ulozData({ PrilohyKomentar: data });
  };
  handleOnChange = (name, value) => {
    this.setState({ [name]: value });
  };

  deleteFile = (index) => {
    const filesNames = this.state.filesNames.filter((item, i) => i !== index);
    const prilohy = this.state.prilohy.filter((item, i) => i !== index);
    this.setState({ prilohy: prilohy, filesNames: filesNames });
  };
  handleOnChangeUpload = async (name, files) => {
    const maxNameLength = 100;
    const modified = files.filter(f => f.name.length > maxNameLength).map(f => f.name);
    const mFiles = await Promise.all(
      files.map(async (f) => {
        const rawFile = await f.getRawFile();
        const name = f.name.length > maxNameLength ? f.name.replace(f.extension, "").substr(0, maxNameLength - f.extension.length) + f.extension : f.name;
        return { name: name, rawFile: rawFile }
      })
    );
    if (modified.length > 0) {
      this.props.showMsg("Vybraným súborom (" + modified.length + ") bol orezaný názov súboru na " + maxNameLength + " znakov.");
    }
    const prilohyOld = this.state.prilohy;
    const fileNamesOld = this.state.filesNames;
    const filesNames = [...fileNamesOld, ...mFiles.filter(f => !fileNamesOld.includes(f.name)).map(f => f.name)];
    const prilohy = [...prilohyOld, ...mFiles.filter(f => !fileNamesOld.includes(f.name)).map(f => f.rawFile)];
    this.setState({ prilohy: prilohy, filesNames: filesNames });
  };

  componentDidMount = async () => {
    this.props.setRef(this);
  };

  render() {
    const { onKeyDown, cancel, moveBack, moveNext, className, index } = this.props;
    const { KOMENTAR, filesNames, titles } = this.state;
    const media = window.matchMedia('only screen and (min-width: 768px)');

    return (
      <div className={`row m-0 ${className}`}>
        <div className={media.matches ? "col-6 offset-3 p-0 forWeb" : "col p-0 forMobile"}>
          <div className="card formular">
            <div className="form-body">
              {/* FORM */}
              <Tooltip>
                <form
                  id={`webForm${index}`}
                  className="k-form"
                  onSubmit={moveNext}
                  onKeyDown={onKeyDown}
                >
                  {/* TITLE */}
                  <div className="card-title">
                    <div>Prílohy a komentár</div>
                  </div>

                  <p>&nbsp;</p>
                  {/* KOMNETAR */}
                  <div className="k-form-field">
                    <span>{"Komentár:"}</span>
                    <Textarea
                      title={titles.komentar}
                      name="KOMENTAR"
                      onChange={this.handleOnChange}
                      value={KOMENTAR}
                      defaultExpanded={true}
                      tab-index={0}
                    />
                  </div>
                  {/* PRILOHY */}
                  <div className="k-form-field">
                    <span>{"Prílohy"}</span>
                    <Upload
                      name={"prilohy"}
                      onChange={this.handleOnChangeUpload}
                      value={null}
                      url={"x"}
                      restrictions={{
                        allowedExtensions: [],
                      }}
                      autoUpload={false}
                      multiple={true}
                      showActionButtons={true}
                      requiredMaximumSize={"1MB"}
                      tab-index={1}
                    />
                  </div>

                  <p>&nbsp;</p>
                  <div style={{ fontWeight: "bold" }}>Vybraté prílohy:</div>
                  {filesNames.map((fileName, i) => (
                    <div className="file-item row" key={i}>
                      <div className="col-10">{fileName}</div>
                      <div className="col-2">
                        <Button key={i} primary iconClass="k-icon k-font-icon k-i-close" onClick={(e) => { this.deleteFile(i); }} />
                      </div>
                    </div>
                  ))}

                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button
                      primary
                      label="Zrusiť"
                      onClick={cancel}
                      tab-index={3}
                    />
                    <div className="flexGroup">
                      <Button primary label="Späť" onClick={moveBack} />
                      <Button
                        type="submit"
                        label="Ďalej"
                        primary={true}
                        tab-index={2}
                      />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  ulozData: (data) => dispatch(ziadostActions.ulozData(data)),
  showMsg: (msg, msgType = 'ok', isDialog = false, title) => dispatch(showMsg(msg, msgType, isDialog, title))  
});

PrilohyKomentare.propTypes = {
  setRef: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  moveNext: PropTypes.func.isRequired,
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  className: PropTypes.string,
  getStepperState: PropTypes.func,
  ulozData: PropTypes.func,
  ziadost: PropTypes.object,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PrilohyKomentare)
);
